import { createContext, useContext, useReducer } from 'react';
import { ContractSearchState, ContractSearchReducer, ACTION_TYPES } from './contract-search-reducer';
import { IContractPageRequest } from '../../../../model/scp/contract/request/contract-paged-request';
import { ContractSortField } from '../../../../model/scp/contract/contract-sort-field';
import { SortDirection } from '../../../../model/scp/base/sort-direction';

const ContractSearchContext = createContext<ContractSearchState | undefined>(undefined);
const ContractSearchDispatchContext = createContext({} as any);

const ContractSearchProvider = ({ children }: { children: React.ReactNode }) => {
    const initialState: ContractSearchState = {
        typeContract: [],
        categoryProcess: [],
        parameters: {
            page: 0,
            pageSize: 100,
            sortBy: ContractSortField.UpdatedDate,
            sortDirection: SortDirection.Descending
        } as IContractPageRequest,
        searchTrigger: 0,
    };

    const [state, dispatch] = useReducer(ContractSearchReducer, initialState);

    return (
        <ContractSearchContext.Provider value={state}>
            <ContractSearchDispatchContext.Provider value={dispatch}>
                {children}
            </ContractSearchDispatchContext.Provider>
        </ContractSearchContext.Provider>
    );
}

const useContractSearchState = () => {
    const context = useContext(ContractSearchContext);
    if (context === undefined) {
        throw new Error('useContractSearchState must be used within a ContractSearchProvider');
    }
    return context;
}

const useContractSearchDispatch = () => {
    const context = useContext(ContractSearchDispatchContext);
    if (context === undefined) {
        throw new Error('useContractSearchDispatch must be used within a ContractSearchProvider');
    }
    return context;
}

export { ContractSearchProvider, useContractSearchDispatch, useContractSearchState, ACTION_TYPES };
